import LoginHeader from './header'
import { Formik, Form } from 'formik'
import UseSendCode from './hooks/useSendCode'
import FormikInput from 'components/formikFields/input'
import { initialValues } from './utilities/initialValues'
import { LoginSchema } from './utilities/loginSchema'
import NextBtnIcon from '../../../assets/images/rectangle/next_button.svg'
import { toEnglishDigits } from 'utilities/helper/toEnglishNumber'
import { FormEvent, useEffect, useState } from 'react'
import ShareNumberButton from 'components/miniapp/shareNumberButton'
import { useShareNumber } from 'components/miniapp/shareNumberButton/useShareNumber'
import MessengerLogin from 'components/miniapp/messengerLogin'
import DotsLoading from 'components/loadings/dotsLoading'
import { checkLinkedNow, isMiniapp } from 'modules/miniapp'
import { POST_LOGIN_PATH } from 'utilities/navigation'

const Policy = () => (
    <div className=" mt-4 text-center text-xs font-normal">
        <p>
            با ثبت‌نام و ورود به همیان،‌{' '}
            <a
                className=" text-blue-1 cursor-pointer"
                href="https://hamyanapp.com/policy/"
                target="_blank"
                rel="noopener noreferrer"
            >
                قوانین و مقررات
            </a>{' '}
            را می پذیرم.
        </p>
    </div>
)

const Login = () => {
    const [isSubmit, setIsSubmit] = useState<boolean>(false)
    const { mutate } = UseSendCode(setIsSubmit)

    // Inside a messenger the one-tap button comes FIRST and the phone form is
    // what you ask for. `otherNumber` is that ask.
    const [otherNumber, setOtherNumber] = useState(false)
    const messenger = useShareNumber({
        variant: 'hero',
        declinedMessage:
            'شماره دریافت نشد. دوباره تلاش کنید یا با شمارهٔ دیگری وارد شوید.',
    })

    // Someone can leave the mini app, share their number with the bot, and come
    // back — the webhook links them while this page sits idle. Re-check on the
    // way back in so they are not still staring at a login form.
    useEffect(() => {
        if (!isMiniapp()) return
        const onVisible = () => {
            if (document.visibilityState !== 'visible') return
            checkLinkedNow().then((linked) => {
                if (linked) window.location.replace(POST_LOGIN_PATH)
            })
        }
        document.addEventListener('visibilitychange', onVisible)
        return () => document.removeEventListener('visibilitychange', onVisible)
    }, [])

    const sendOtp = (phone: string) => {
        if (isSubmit) return
        mutate({ phone_number: phone })
        setIsSubmit(true)
    }

    const handleOnChange = (event: FormEvent) => {
        //@ts-ignore
        if (!isSubmit && event.target.value.length === 11) {
            //@ts-ignore
            sendOtp(toEnglishDigits(event.target.value))
        }
    }

    // The SDK has not said yet whether this client can share a number. Hold
    // the layout rather than flash a phone form at someone who is about to get
    // the one-tap button — that flash is exactly the nudge we are removing.
    if (messenger.available === null) {
        return (
            <div className="flex flex-col items-center h-screen">
                <LoginHeader subtitle=" " />
                <div className="mt-10">
                    <DotsLoading />
                </div>
            </div>
        )
    }

    if (messenger.available && !otherNumber) {
        return (
            <div className="flex flex-col h-screen">
                <LoginHeader subtitle="برای ورود یا ثبت‌نام، دکمهٔ زیر را بزنید." />
                <MessengerLogin
                    stage={messenger.stage}
                    phone={messenger.phone}
                    disabled={isSubmit}
                    onShare={messenger.share}
                    onUseOtp={sendOtp}
                    onOtherNumber={() => setOtherNumber(true)}
                />
                <div className="mt-auto mb-6">
                    <Policy />
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="flex flex-col justify-between items-center h-screen relative ">
                <div className=" flex flex-col w-full">
                    <LoginHeader />
                    <Formik
                        initialValues={initialValues}
                        validationSchema={LoginSchema}
                        onSubmit={async (values) => {
                            sendOtp(toEnglishDigits(values.phoneNumber))
                        }}
                    >
                        {({ submitForm, setFieldValue }) => (
                            <Form onChange={handleOnChange}>
                                <div className=" mx-3 mt-3 text-sm font-normal">
                                    <FormikInput
                                        type="number"
                                        label="شماره موبایل"
                                        name="phoneNumber"
                                        placeholder="برای مثال: ۰۹۱۲۳۴۵۶۷۸۹"
                                        className="text-sm font-normal"
                                        min={0}
                                    />
                                    {/* Mini-app only, and only reached through
                                        «با شمارهٔ دیگری وارد شوید»: the way
                                        back to the one-tap login. The number
                                        it fills is unsigned, so the SMS code
                                        below still does the proving. */}
                                    <ShareNumberButton
                                        disabled={isSubmit}
                                        // Fill only. Sharing the number is
                                        // often enough to log in outright, so
                                        // firing an OTP here would bill us for
                                        // a message the user never needs.
                                        onPrefill={(phone) =>
                                            setFieldValue('phoneNumber', phone)
                                        }
                                        // The explicit fallback, after the wait
                                        // came to nothing: same path as typing
                                        // eleven digits.
                                        onUseOtp={(phone) => {
                                            setFieldValue('phoneNumber', phone)
                                            sendOtp(phone)
                                        }}
                                    />
                                </div>
                                <Policy />
                                <div className="absolute bottom-5 right-5">
                                    <img
                                        src={NextBtnIcon}
                                        alt="nex-btn-icon"
                                        onClick={submitForm}
                                        className=" cursor-pointer"
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default Login
